import type { ReactNode } from "react";
import { AuthContext } from "@/context/AuthContext";
import { useAuthProvider } from "@/context/useAuthProvider";

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const auth = useAuthProvider();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};